import { JobSearchResultContainer } from '@/modules/job/presentation/containers';

export const JobSearchResultsScreen = () => {
	return <JobSearchResultContainer />;
};
